import React, { useState } from 'react';
import Dinero from 'dinero.js';
import ICosts from '@/models/viewModels/ICosts';
import { IToggleButton, ToggleButtonGroup } from '@into-discovery/browsewebshared';
import colorStyles from '@/styles/utils/variables.module.scss';
import styles from './typical-costs-acyear-breakdown.module.scss';

type Props = {
  acYearCostsBreakdown: ICosts[];
  programType: string;
};

// TODO: This should come from data

export default function AcYearCostsBreakdown({ acYearCostsBreakdown, programType }: Props) {
  const acYears = acYearCostsBreakdown.filter((e) => e.costs.length).map((e) => e.academicYear);
  const [acYear, setAcYear] = useState(acYears[0]);

  const RemoveDecimals = (amount) => {
    if (amount === null) return 0;
    return amount.slice(0, -3);
  };
  const selectedYearCosts = acYearCostsBreakdown.find((e) => e.academicYear === acYear);
  const { currencyCode } = selectedYearCosts.costs[0];
  const selectedYearMinTotal = selectedYearCosts.costs.reduce((acc, value) => acc + value.min, 0);
  const selectedYearMaxTotal = selectedYearCosts.costs.reduce((acc, value) => acc + value.max, 0);
  const changeAcYear = (year: string) => {
    setAcYear(acYearMap[year]);
  };
  const acYearMap: { [key: string]: string } = {};

  const buttonProps: IToggleButton[] = acYears.map((year: string) => {
    acYearMap[`${year}-${programType}`] = year;
    return {
      label: year,
      value: `${year}-${programType}`,
      isChecked: acYear === year,
      group: `acYearGroup-${programType}`,
      handleOnToggle: changeAcYear,
      inputColor: colorStyles.primary,
    };
  });

  return (
    <section id={`${programType}-breakdown-section`}>
      <div id={`${programType}-acyear-title`} className="fw-bold text-color-primary">
        Academic year
      </div>
      <div className="mt-2">
        {acYears.length && (
          <ToggleButtonGroup customClass={styles.button_group} toggleButtonProps={buttonProps} />
        )}
      </div>

      <div className="tab-content-table px-3">
        <div className="row tab-content-table-row tab-content-table-head">
          <div className="col-lg-4 col fw-bold tab-content-table-col">
            <p className="m-0">Cost</p>
          </div>
          <div className="col-lg-8 col text-end fw-bold tab-content-table-col">
            <p className="m-0">Approximate amount per year ({currencyCode})</p>
          </div>
        </div>
        {selectedYearCosts.costs.map((cost) => (
          <div
            className="row tab-content-table-row tab-content-table-body"
            key={`${cost.displayName}-${programType}`}
          >
            <div className="col col-lg-4 tab-content-table-col">
              <p className="m-0">{cost.displayName}</p>
            </div>
            <div className="col col-lg-8 text-end tab-content-table-col">
              <p className="m-0">
                {`${RemoveDecimals(
                  Dinero({
                    amount: Math.floor(cost.min),
                    currency: cost.currencyCode,
                    precision: 0,
                  }).toFormat(),
                )} - ${RemoveDecimals(
                  Dinero({
                    amount: Math.floor(cost.max),
                    currency: cost.currencyCode,
                    precision: 0,
                  }).toFormat(),
                )}`}
              </p>
            </div>
          </div>
        ))}
        {selectedYearCosts.costs?.length > 1 && (
          <div
            id={`${programType}-est-total-row`}
            className="row tab-content-table-row tab-content-table-body"
          >
            <div
              id={`${programType}-est-total-div`}
              className="col-lg-4 col fw-bold tab-content-table-col"
            >
              <p className="m-0">ESTIMATED TOTAL</p>
            </div>
            <div
              id={`${programType}-est-total-amnt-div`}
              className="col-lg-8 col fw-bold text-end tab-content-table-col"
            >
              <p className="m-0 d-inline" id={`${programType}-total-min`}>
                {RemoveDecimals(
                  Dinero({
                    amount: Math.floor(selectedYearMinTotal),
                    currency: selectedYearCosts.costs[0].currencyCode,
                    precision: 0,
                  }).toFormat(),
                )}
              </p>
              {` `}-{` `}
              <p className="m-0 d-inline" id={`${programType}-total-max`}>
                {RemoveDecimals(
                  Dinero({
                    amount: Math.floor(selectedYearMaxTotal),
                    currency: selectedYearCosts.costs[0].currencyCode,
                    precision: 0,
                  }).toFormat(),
                )}
              </p>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
